export enum ABINROUTES {
    RAPPORT_PAGE = 'abin-rapport',
    SELECT_DATA_PAGE = 'valj-rapport',
    UPPFOLJNINGSRAPPORT = 'uppfolj-rapport'
}
